module.exports = __webpack_public_path__ + "img/lap.c3cd0b27.webp";